import { createSelector } from 'reselect'

const getState = state => state.passenger
const bookingsIDsSelector = state => getState(state).bookingsIDs || []
const blacklistIDsSelector = state => getState(state).blacklistIDs
const isLoadingSelector = state => getState(state).isLoading
const bookingsSelector = state => getState(state).bookings
const firstNameSelector = state => getState(state).firstName
const lastNameSelector = state => getState(state).lastName

const bookingsLengthSelector = createSelector(
  bookingsIDsSelector,
  bookingsIDs => bookingsIDs.length
)

const bookingsBlacklistLengthSelector = createSelector(
  blacklistIDsSelector,
  blacklistIDs => !!blacklistIDs && blacklistIDs.length
)

export {
  bookingsIDsSelector,
  blacklistIDsSelector,
  bookingsBlacklistLengthSelector,
  bookingsLengthSelector,
  isLoadingSelector,
  bookingsSelector,
  firstNameSelector,
  lastNameSelector,
}


// WEBPACK FOOTER //
// ./src/reduxModules/selectors/PassengerSelectors.js